import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { environment } from 'src/environments/environment';

export const passwordsDontMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const newPassword = control.get('newPassword');
  const confirmNewPassword = control.get('confirmNewPassword');

  return newPassword && confirmNewPassword && newPassword.value !== confirmNewPassword.value ? { passwordsDontMatch: true } : null;
};

export const emailsDontMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const emailChange = control.get('emailChange');
  const emailChangeConfirm = control.get('emailChangeConfirm');

  return emailChange && emailChangeConfirm && emailChange.value !== emailChangeConfirm.value ? { emailsDontMatch: true } : null;
};

export const phonesDontMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const mobileChange = control.get('mobileChange');
  const mobileChangeConfirm = control.get('mobileChangeConfirm');
  console.log(`validating ${mobileChange} ${mobileChangeConfirm} matching`);
  return mobileChange && mobileChangeConfirm && mobileChange.value !== mobileChangeConfirm.value ? { phonesDontMatch: true } : null;
};


@Injectable({ providedIn: 'root' })
export class FuncsService {
  constructor() { }

  private VALIDATION_PATTERNS: Map<string, string> = new Map([
    ["email", "^.*@.*\..*",],
    ["cf_o_piva", "^([A-Za-z]{6}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{3}[A-Za-z]{1}|[0-9]{11})$"],
    ["phone", !environment.overwritePhoneRegex ? "^(\\+[0-9]{1,3})([0-9]{1,3})([0-9]{4,14})$" : environment.overwritePhoneRegex],
    ["otp", "^[0-9]{6}$"],
    ["password", "^(?!.*(.)\\1{2})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})^(?!.*STRING1|.*STRING2|.*STRING3|.*STRING4|.*STRING5|.*STRING6|.*STRING7|.*STRING8).*$"]])

  getValidationPattern(key: string): string {
    //  console.log("password pattern", this.VALIDATION_PATTERNS.get('password'))
    return this.VALIDATION_PATTERNS.get(key);
  }

  getValidationErrorMessage(errors: any): string {
    if (!errors) {
      return "";
    }

    if (errors.required) {
      return $localize`:Generic.ValidationError.Required|Errore che si ha quando non viene inserito un input obbligatorio@@Generic.ValidationError.Required:Questo campo è obbligatorio`
    } if (errors.pattern) {
      return $localize`:Generic.ValidationError.Pattern|Errore che si ha quando l'input inserito non rispetta il formato richiesto@@Generic.ValidationError.Pattern:Il formato non è corretto`
    }
    if (errors.minLength) {
      return $localize`:Generic.ValidationError.MinLength|Errore che si ha quando l'input inserito è troppo breve@@Generic.ValidationError.MinLength:Lunghezza minima non rispettata`
    }
    if (errors.maxLength) {
      return $localize`:Generic.ValidationError.MaxLength|Errore che si ha quando l'input inserito è troppo lungo@@Generic.ValidationError.MaxLength:Lunghezza massima non rispettata`
    }

    return $localize`:Generic.ValidationError.GenericError|Errore generico per un input@@Generic.ValidationError.GenericError:Input non valido`;
  }
}